<div class="cart" [class.invalid]="!vm().product?.isAvailable">
    <div class="top">
        <div class="image" [ariaLabel]="vm().product.name">
            <lib-light-carousel [images]="vm().smallImagesForCards" [label]="vm().product.name" />
        </div>
        <div class="brand">
            <h2 class="label">{{ vm().product.brandName | uppercase }}</h2>
            <h2 class="body-0">{{ vm().product.name }}</h2>
            @if (vm().product?.estimatedShippingDays) {
                <p class="body-1 shipping-info">
                    {{ vm().product.estimatedShippingDays }}
                </p>
            }
            <!--
      <span class="product-info body-1">[Product variant]: [Selection]</span>
      <span class="product-info body-1">[Microcopy]</span>
      -->
        </div>
        <div class="content">
            <div class="footer-part">
                <div class="quantity">
                    <div class="quantity-actions">
                        <lib-counter
                            [count]="vm().product.quantity"
                            [max]="orderLimitReached() ? vm().product.quantity : maxQuantity()"
                            [productName]="vm().product.name"
                            (change)="onQuantityChange($event, vm().product.productId)"
                        ></lib-counter>
                        <button
                            class="trash-btn"
                            type="button"
                            [attr.aria-label]="'Remove ' + vm().product.name + ' from cart'"
                            (click)="onRemove(vm().product.productId)"
                        >
                            <mat-icon svgIcon="ico_trash"></mat-icon>
                        </button>
                    </div>
                </div>
                <div class="totals">
                    <span class="totals__price">
                        <p class="link">{{ vm().displayNewPrice | appDigitsGrouping }} {{ rewardName() }}</p>
                    </span>

                    @if (vm().shouldShowOldPoints) {
                        <lib-cart-old-price [price]="vm().displayOldPrice" />
                    }
                </div>
            </div>
        </div>
    </div>
    @if (!vm().product?.isAvailable) {
        <lib-alert-message
            text="This item is no longer available. Please remove it from your cart"
            type="error"
        ></lib-alert-message>
    }
    @if (limitMessage()) {
        @if (mode() === 'mobile') {
            <!-- Mini Cart: red triangle, no background (AC02) -->
            <lib-alert-message
                class="limit-message"
                iconOverride="ico_vector"
                type="error"
                variant="order-limit"
                [text]="limitMessage()!"
            ></lib-alert-message>
        } @else {
            <!-- Cart page: grey bar, orange ring, dark text (AC05) -->
            <lib-alert-message
                class="limit-message limit-message--bar"
                iconSize="small"
                type="warning"
                typography="body-2"
                [inline]="true"
                [text]="limitMessage()!"
            ></lib-alert-message>
        }
    }
</div>
